import {flushSync} from 'react-dom'

export const SUCCESS_HOLD_MS = 350
export const EXIT_MS = 550

export function skipMotion(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false
}

export function wait(ms: number): Promise<void> {
  if (skipMotion()) return Promise.resolve()
  return new Promise((resolve) => setTimeout(resolve, ms))
}

type ViewTransitionDocument = Document & {
  startViewTransition?: (update: () => void) => unknown
}

export function swapView(update: () => void): void {
  const doc = document as ViewTransitionDocument
  if (skipMotion() || typeof doc.startViewTransition !== 'function') {
    update()
    return
  }
  doc.startViewTransition(() => {
    flushSync(update)
  })
}

export async function playExit(): Promise<void> {
  if (skipMotion()) return
  const card = document.querySelector<HTMLElement>('[data-auth-card]')
  const iris = document.querySelector<HTMLElement>('[data-auth-iris]')
  if (!card || !iris) return

  const box = card.getBoundingClientRect()
  const at = `at ${Math.round(box.left + box.width / 2)}px ${Math.round(
    box.top + box.height / 2,
  )}px`
  iris.style.transition = 'none'
  iris.style.clipPath = `circle(0 ${at})`
  iris.getBoundingClientRect()
  iris.style.transition = `clip-path ${EXIT_MS}ms cubic-bezier(0.7, 0, 0.2, 1)`
  iris.style.clipPath = `circle(150vmax ${at})`
  await wait(EXIT_MS)
}
